import { ofetch as _ofetch } from "ofetch";

// const sourceToken = env.NEXT_PUBLIC_LOGTAIL_SOURCE_TOKEN;

// class LogtailNodeCustom extends Node {
//   constructor(
//     sourceToken: string,
//     options?: ConstructorParameters<typeof Node>[1]
//   ) {
//     super(sourceToken, options);

//     const sync = async (logs: any[]): Promise<any[]> => {
//       const res = await fetch(this._options.endpoint, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${this._sourceToken}`,
//           "User-Agent": "logtail-js(node)"
//         },
//         body: JSON.stringify(logs)
//       });

//       if (res.ok) {
//         return logs;
//       }

//       throw new Error(res.statusText);
//     };

//     this.setSync(sync);
//   }
// }

// const logger =
//   typeof window === "undefined"
//     ? new LogtailNodeCustom(sourceToken)
//     : new Browser(sourceToken);

// export const logOfetch = _ofetch.create({
//   onRequest({ options }) {
//     Object.defineProperty(options, "_start", {
//       enumerable: true,
//       value: Date.now()
//     });
//   },
//   async onResponse({ response, options }) {
//     const duration = Date.now() - (options as { _start: number })._start;
//     log({
//       url: response.url,
//       method: options?.method || "GET",
//       duration,
//       payload: options
//     });
//     await logger.flush();
//   }
// });

// export const logFetch: typeof globalThis.fetch = async (...args) => {
//   const then = Date.now();
//   const result = await fetch(...args);
//   const now = Date.now();
//   const duration = now - then;
//   const init = args[1] as RequestInit;

//   log({
//     url: args[0].toString(),
//     method: init?.method || "GET",
//     duration,
//     payload: init
//   });
//   await logger.flush();
//   return result;
// };
// const log = ({
//   url,
//   method,
//   duration,
//   payload
// }: {
//   url: string;
//   method: string;
//   duration: number;
//   payload?: any;
// }) => {
//   const type = typeof window === "undefined" ? "rsc" : "client";
//   if (!url.includes("centra")) return;
//   logger.info(`[${method}] <${type}> ${url}`, {
//     duration_ms: duration,
//     duration: duration / 1000,
//     method,
//     url,
//     log_id,
//     payload
//   });
// };
// const log_id = "build_1";

const nativeFetch = fetch;

export { nativeFetch as fetch, _ofetch as ofetch };
